<template>
  <div class="r-table r-table--5cols r-table--collapse" :style="styles">
    <div class="r-table-row r-table-row--head table-title">
      <div class="r-table-cell time-cell column-heading">
        Amount: {{ getSunAmount(stats) }}
      </div>
    </div>

    <div class="r-table-row r-table-row--head">
      <div class="r-table-cell time-cell column-heading">
        <div>DEP-AMT</div>
        <div @click.stop="applyTableSortingAlpha('alpha')" class="fa">
          <i class="fas fa-sort-alpha-down" v-if="!sortOrder['alpha']"></i>
          <i class="fas fa-sort-alpha-up" v-if="sortOrder['alpha']"></i>
        </div>
      </div>
      <div class="r-table-cell atm-cell column-heading">
        <div>AMT</div>
        <div @click.stop="applyTableSortingNum('numeric', 'value')" class="fa">
          <i class="fas fa-sort-numeric-down" v-if="!sortOrder['numeric']"></i>
          <i class="fas fa-sort-numeric-up" v-if="sortOrder['numeric']"></i>
        </div>
      </div>
    </div>
    <transition-group name="flip-list" tag="div" class="flip-wrapper">
      <div class="r-table-row" v-for="item in stats" :key="item.title">
        <div class="r-table-cell time-cell">
          <div class="r-table-cell--heading">Time</div>
          <div class="r-table-cell--content date-content">
            {{ item.title }}
          </div>
        </div>
        <div class="r-table-cell atm-cell">
          <div class="r-table-cell--content title-content">
            {{ item.value }}
          </div>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: "MiniDepStatTableDepAmounts",
  props: {
    stats: {
      type: Array
    },
    maxMiniTablesHeight: {
      type: String
    }
  },
  data() {
    return {
      sortOrder: {
        alpha: false,
        numeric: false
      }
    };
  },
  methods: {
    getSunAmount(stats) {
      //Function returns total sum of deposit amounts for day
      let sum = 0;
      stats.forEach(item => {
        sum += item.title * item.value;
      });
      return sum;
    },
    applyTableSortingAlpha(column) {
      this.sortOrder[column] = !this.sortOrder[column];
      if (this.sortOrder[column]) {
        this.stats = this.stats.sort(function(a, b) {
          if (a.title > b.title) {
            return -1;
          }
          if (a.title < b.title) {
            return 1;
          }
          return 0;
        });
      } else {
        this.stats = this.stats.sort(function(a, b) {
          if (a.title < b.title) {
            return -1;
          }
          if (a.title > b.title) {
            return 1;
          }
          return 0;
        });
      }
    },
    applyTableSortingNum(sortType, key) {
      this.sortOrder[sortType] = !this.sortOrder[sortType];
      if (this.sortOrder[sortType]) {
        this.stats = this.stats.sort((a, b) => {
          return b[key] - a[key];
        });
      } else {
        this.stats = this.stats.sort((a, b) => {
          return a[key] - b[key];
        });
      }
    }
  },
  computed: {
    styles() {
      return {
        "--max-height": this.maxMiniTablesHeight
      };
    }
  }
};
</script>

<style scoped lang="scss">
/***************** div flex table style  STARTS**********************/
$breakpoint: 750px;
$tableMaxHeight: var(--max-height);
$heading-color: #c12fff;

* {
  box-sizing: border-box;
}

.wrapper {
  width: 100%;
  max-width: 1000px;
  margin: 1em auto;
  padding: 1em;
}

.is-striped {
  /*background-color: rgba(233, 200, 147, 0.2);*/
  background-color: #f8f8f8;
}

/* Table column sizing
================================== */
.name-cell {
  width: 15%;
}
.atm-cell {
  width: 15%;
}
.dep-hour-cell {
  width: 15%;
}
.lead-reg-cell {
  width: 25%;
}
.campaign-cell {
  width: 15%;
}
.continent-cell {
  width: 15%;
}

/* Apply styles
================================== */
.r-table {
  display: flex;
  flex-wrap: wrap;
  /*margin: 0 0 3em 0;*/
  padding: 0;
  //box-shadow: 0 0 40px rgba(0, 0, 0, 0.2);

  .r-table-row {
    width: 100%;
    display: flex;

    .r-table-cell {
      box-sizing: border-box;
      flex-grow: 1;
      padding: 0.8em 1.2em;
      //padding: 0.3em 0.5em;
      overflow: hidden; // Or flex might break
      list-style: none;

      &.column-heading {
        background-color: $heading-color;
        color: white;
        padding: 1em;
        display: flex;
        justify-content: center;
      }

      .r-table-cell--heading {
        display: none;
      }

      .r-table-cell--content {
        a {
          font-size: 2em;
          color: #333;
        }

        .webinar-date {
          font-weight: 700;
        }
      }
    }
  }
}

/* Responsive
==================================== */
@media all and (max-width: $breakpoint) {
  .is-striped {
    background-color: white;
  }

  .r-table--collapse {
    display: block;
    width: 100%;
    padding: 1em;
    box-shadow: none;

    .r-table-row {
      box-sizing: border-box;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 2em;
      //box-shadow: 0 0 40px rgba(0, 0, 0, 0.2);

      .r-table-cell {
        width: 100% !important;
        display: flex;
        align-items: center;

        .r-table-cell--heading {
          display: inline-block;
          flex: 1;
          max-width: 120px;
          min-width: 120px;
          color: $heading-color;
          font-weight: 700;
          border-right: 1px solid #ccc;
          margin-right: 1em;
        }

        .r-table-cell--content {
          flex: 2;
          padding-left: 1em;
        }
      }
    }

    .atm-cell {
      background-color: $heading-color;
      color: white;
      font-weight: 700;
      order: -1;

      .r-table-cell--content {
        padding-left: 0 !important;
      }
    }

    .r-table-row--head {
      display: none;
    }
  }
}

// Non-Flex modernizer fallback
.no-flexbox .r-table {
  display: block;

  &.r-table-cell {
    width: 100%;
  }
}

.date-title {
  font-size: 14px;
  font-weight: 700;
}

/***************** div flex table style ENDS**********************/

/***************** Custom table columns style Starts**********************/
.atm-cell {
  width: 40% !important;
}
.time-cell {
  width: 60% !important;
}
/***************** Custom table columns style Starts**********************/

/***************** Custom scroll style Starts**********************/

.flip-wrapper::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

.flip-wrapper::-webkit-scrollbar {
  width: 7px;
  background-color: #c12fff;
  /*display: none;*/
}

.flip-wrapper::-webkit-scrollbar-thumb {
  background-color: #c12fff;
  border: 2px solid #a629db;
  border-radius: 5px;
}
/***************** Custom scroll style Ends**********************/
.flip-wrapper {
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: $tableMaxHeight;
}
.flip-list-move {
  transition: transform 1s;
}
.r-table--collapse {
  height: fit-content;
}
.r-table {
  margin-right: 5px;
}
.r-table-row {
  border-bottom: 1px solid #ebe5e5;
}
.table-title {
  font-weight: 600;
}
.column-heading div {
  padding-top: 5px;
  margin-right: 10px;
}
</style>
